export default __webpack_public_path__ + "static/media/virtualpad_bt_l.6c4820dd.png";